import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // static targets = ["packagePanel", "packageRadio", "selectedPackageId", "otherPackages", "toggleOtherPackages"]

  // connect() {
  //   this.updateSelectedPackage()
  // }

  static targets = [
    "packagePanel", 
    "packageRadio", 
    "selectedPackageId", 
    "packageSection", 
    "otherPackages",
    "toggleOtherPackages",
    "perks",
    "togglePerks"
  ]

  connect() {
    this.initializeSelectedPackage()
    // if there is no initial selected package and we have packages, select the first one
    if (!this.selectedPackageIdTarget.value && this.packagePanelTargets.length > 0) {
      this.selectPackageById(this.packagePanelTargets[0].dataset.packageId)
    }

    // Dispatch event for discount code widget to listen to
    this.dispatchPackageSelectedEvent()

    // Initialize payment button states based on terms and package selection
    setTimeout(() => {
      this.updatePaymentButtonsState()
      this.disableDepositIfPackageTooSmall()
    }, 100)
  }

  initializeSelectedPackage() {
    // Check if there's already a selected package from the hidden field
    if (this.selectedPackageIdTarget && this.selectedPackageIdTarget.value) {
      this.selectPackageById(this.selectedPackageIdTarget.value)
    } else if (this.hasPackageSectionTarget && this.packageSectionTarget.dataset.initialSelectedPackageId) {
      const initialSelectedPackageId = this.packageSectionTarget.dataset.initialSelectedPackageId
      if (initialSelectedPackageId) {
        this.selectPackageById(initialSelectedPackageId)
      }
    } else {
      this.updateSelectedPackage()
    }
  }

  selectPackage(event) {
    const clickedPanel = event.currentTarget
    const packageId = clickedPanel.dataset.packageId
    this.selectPackageById(packageId)
  }

  selectPackageById(packageId) {
    this.packagePanelTargets.forEach(panel => {
      const radio = panel.querySelector('input[type="radio"]')
      const isSelected = panel.dataset.packageId === packageId

      if (isSelected) {
        panel.classList.add("Panel--success")
        panel.classList.remove("Panel--subtle")
        panel.classList.remove("Panel--white")
        radio.checked = true
        this.selectedPackageIdTarget.value = packageId
      } else {
        panel.classList.remove("Panel--success")
        panel.classList.add("Panel--subtle")
        panel.classList.add("Panel--white")
        radio.checked = false
      }
    })

    // Dispatch event for discount code widget
    this.dispatchPackageSelectedEvent()
    this.disableDepositIfPackageTooSmall()
  }

  updateSelectedPackage() {
    const selectedRadio = this.packageRadioTargets.find(radio => radio.checked)
    if (selectedRadio) {
      // Ensure the hidden field is synced with the radio button value
      this.selectedPackageIdTarget.value = selectedRadio.value
      this.selectPackageById(selectedRadio.value)
    } else {
      // Dispatch event even if no package is selected
      this.dispatchPackageSelectedEvent()
    }
  }

  dispatchPackageSelectedEvent() {
    const selectedPanel = this.packagePanelTargets.find(panel => {
      const radio = panel.querySelector('input[type="radio"]')
      return radio && radio.checked
    })

    // Dispatch a custom event that the discount code widget can listen to
    this.element.dispatchEvent(
      new CustomEvent('packageSelected', {
        bubbles: true,
        detail: {
          hasPackage: !!this.selectedPackageIdTarget.value,
          requiresHighSchool: selectedPanel?.dataset.requiresHighSchoolOnEnrollment === "true"
        }
      })
    )
    
    // Also check if terms are checked and enable/disable payment buttons accordingly
    this.updatePaymentButtonsState()
  }
  
  updatePaymentButtonsState() {
    const termsCheckbox = document.getElementById('driving-school-terms-conditions')
    if (!termsCheckbox || !termsCheckbox.checked) {
      return
    }
    
    // If terms are checked and package is selected, enable buttons
    // The widget handles deposit button state for discount codes
    const hasPackage = !!this.selectedPackageIdTarget.value && this.selectedPackageIdTarget.value.trim() !== '' && this.selectedPackageIdTarget.value !== '0'
    
    if (hasPackage) {
      const paymentButton = document.getElementById('payment-button')
      const payLaterButton = document.getElementById('pay-later-button')
      
      if (paymentButton) {
        paymentButton.disabled = false
      }
      if (payLaterButton) {
        payLaterButton.disabled = false
      }
      
      // Package price check sets the deposit button state
      this.disableDepositIfPackageTooSmall()
    }
  }

  disableDepositIfPackageTooSmall() {
    const payDepositButton = document.getElementById('pay-deposit-button')
    if (!payDepositButton) return

    const selectedPanel = this.packagePanelTargets.find(panel => {
      const radio = panel.querySelector('input[type="radio"]')
      return radio && radio.checked
    })
    if (!selectedPanel) return

    const priceInCents = parseInt(selectedPanel.dataset.priceInCents || '0', 10)
    const depositAmountInCents = Math.round(parseFloat(payDepositButton.dataset.depositAmount || '0') * 100)

    if (depositAmountInCents > 0 && priceInCents < depositAmountInCents) {
      payDepositButton.disabled = true
      return
    }

    // Package price is OK — re-enable only if no other reason to keep disabled
    const termsCheckbox = document.getElementById('driving-school-terms-conditions')
    const termsBlocking = termsCheckbox && !termsCheckbox.checked

    if (!termsBlocking) {
      payDepositButton.disabled = false
    }
  }

  syncPackageIdBeforeSubmit(event) {
    // Ensure hidden field is synced with checked radio button before form submission
    const selectedRadio = this.packageRadioTargets.find(radio => radio.checked)
    if (selectedRadio && this.hasSelectedPackageIdTarget) {
      this.selectedPackageIdTarget.value = selectedRadio.value
    }
  }

  toggleOtherPackages(event) {
    event.preventDefault()
    this.otherPackagesTarget.classList.toggle("u-hidden")
    // switch toggleOtherPackages text
    const toggleText = this.toggleOtherPackagesTarget.innerText

    //check text contains "Show other packages"

    this.toggleOtherPackagesTarget.innerText = toggleText.includes("Show other packages") ? "Hide other packages" : "Show other packages"
  }
  
  togglePerks(event) {
    event.preventDefault()
    const packageId = event.currentTarget.dataset.packageId
    const perksTarget = this.perksTargets.find(target => target.dataset.packageId === packageId)
    const toggleTarget = this.togglePerksTargets.find(target => target.dataset.packageId === packageId)

    if (!perksTarget || !toggleTarget) {
      console.error(`Targets not found for package ID: ${packageId}`)
      return
    }

    const toggleText = toggleTarget.innerText
    toggleTarget.innerText = toggleText.includes("See all perks") ? "Hide all perks" : "See all perks"

    perksTarget.classList.toggle("u-hidden")
    console.log("Toggled perks for package ID:", packageId)
  }
  // selectPackage(event) {
  //   const clickedPanel = event.currentTarget
  //   const radioButton = clickedPanel.querySelector('input[type="radio"]')
  //   radioButton.checked = true
  //   this.selectedPackageIdTarget.value = clickedPanel.dataset.packageId
  //   this.updateSelectedPackage()
  // }

  // updateSelectedPackage() {
  //   this.packagePanelTargets.forEach((panel, index) => {
  //     const radio = this.packageRadioTargets[index]
  //     const isSelected = panel.dataset.selected === "true" || radio.checked

  //     if (isSelected) {
  //       panel.classList.add("Panel--success")
  //       panel.classList.remove("Panel--subtle")
  //       this.selectedPackageIdTarget.value = panel.dataset.packageId
  //       radio.checked = true
  //     } else {
  //       panel.classList.remove("Panel--success")
  //       panel.classList.add("Panel--subtle")
  //     }
  //   })
  // }
}
